"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateRoute = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_router_1 = require("react-router");
exports.PrivateRoute = (0, react_1.memo)(function (_a) {
    var loggedIn = _a.loggedIn, path = _a.path, component = _a.component, exact = _a.exact, redirectTo = _a.redirectTo;
    switch (loggedIn) {
        case undefined:
            return react_1.default.createElement("div", null);
        case false:
            return react_1.default.createElement(react_router_1.Redirect, { to: redirectTo });
        case true:
            return react_1.default.createElement(react_router_1.Route, { exact: exact, path: path, component: component });
    }
});
exports.PrivateRoute.displayName = 'PrivateRoute';
